import {
  V2ProductionCostGetEnergyUnitTreePostResponse,
  V2ProductionCostGetGroupEnergyUnitListPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import electricityActive from './components/imgs/electricityActive.png';
import electricityPassive from './components/imgs/electricityPassive.png';
import waterActive from './components/imgs/waterActive.png';
import waterPassive from './components/imgs/waterPassive.png';
import gasActive from './components/imgs/gasActive.png';
import gasPassive from './components/imgs/gasPassive.png';
import hotSteamActive from './components/imgs/hotSteamActive.png';
import hotSteamPassive from './components/imgs/hotSteamPassive.png';
import compressedAirActive from './components/imgs/compressedAirActive.png';
import compressedAirPassive from './components/imgs/compressedAirPassive.png';
import IndustrialGasActive from './components/imgs/IndustrialGasActive.png';
import IndustrialGasPassive from './components/imgs/IndustrialGasPassive.png';
import haActive from './components/imgs/haActive.png';
import haPassive from './components/imgs/haPassive.png';
import IndustrialLiquidActive from './components/imgs/IndustrialLiquidActive.png';
import IndustrialLiquidPassive from './components/imgs/IndustrialLiquidPassive.png';
import { isNil } from 'lodash-es';
import dayjs from 'dayjs';

type RawEnergyUnit = {
  id?: number;
  name?: string;
  energyUnitGroupId?: number;
  parentId?: number;
  rootId?: number;
  level?: number;
  children?: RawEnergyUnit[];
};

export function convertToTreeSelect(data: V2ProductionCostGetEnergyUnitTreePostResponse['list'] = []) {
  return data.map(group => ({
    label: group.energyUnitGroupName || `分析组 ${group.energyUnitGroupId}`,
    value: `group-${group.energyUnitGroupId}`, // 非选择项 value 可以自定义
    disabled: !group.children?.length, // 第一层不可选
    children: (group.children || []).map(child => convertEnergyUnit(child)),
  }));
}

function convertEnergyUnit(node: RawEnergyUnit): any {
  return {
    label: node.name,
    value: node.id,
    children: (node.children || []).map(child => convertEnergyUnit(child)),
  };
}

export function findFirstDisabledPath(
  nodes: V2ProductionCostGetGroupEnergyUnitListPostResponse['list'] = []
): number | null {
  for (const node of nodes) {
    const currentPath = node.energyUnitId!;
    if (!node.disabled) {
      return currentPath;
    }

    if (node.children) {
      const childPath = findFirstDisabledPath(node.children);
      if (childPath) {
        return childPath;
      }
    }
  }

  return null;
}

export const keepPercentTwoNull = (data?: number): number | null => {
  if (!isNil(data)) {
    return Number((data * 100).toFixed(2));
  } else {
    return null;
  }
};
export const keepPercentTwoLine = (data?: number): number | string => {
  if (!isNil(data)) {
    return Number((data * 100).toFixed(2));
  } else {
    return '--';
  }
};

export const keepTwoOrLine = (data?: number) => {
  if (!isNil(data)) {
    return Number(data.toFixed(2));
  }
  return '--';
};

// 综合能耗设为1
export const GENERAL_CONSUMPTION = 1;

// 工质场景 id 枚举
export enum EnergyMediumSceneIds {
  WATER_SUPPLY_AND_DRAINAGE = 500, // 给排水/用气
  GAS_SUPPLY_AND_CONSUMPTION = 501, // 供气/用气
  HOT_STEAM = 502, // 热蒸汽
  COMPRESSED_AIR = 503, // 压缩空气
  INDUSTRIAL_GASES = 504, // 工业气体
  HEATING_VENTILATION_AND_AIR_CONDITIONING = 505, // 供暖通风与空气调节
  INDUSTRIAL_LIQUIDS = 506, // 工业液体
  ELEC = 507, // 电能
}

// 工质 icon 映射
export const EnergyMediumIconDisplay = {
  [EnergyMediumSceneIds.WATER_SUPPLY_AND_DRAINAGE]: {
    active: waterActive,
    passive: waterPassive,
  },
  [EnergyMediumSceneIds.GAS_SUPPLY_AND_CONSUMPTION]: {
    active: gasActive,
    passive: gasPassive,
  },
  [EnergyMediumSceneIds.HOT_STEAM]: {
    active: hotSteamActive,
    passive: hotSteamPassive,
  },
  [EnergyMediumSceneIds.COMPRESSED_AIR]: {
    active: compressedAirActive,
    passive: compressedAirPassive,
  },
  [EnergyMediumSceneIds.INDUSTRIAL_GASES]: {
    active: IndustrialGasActive,
    passive: IndustrialGasPassive,
  },
  [EnergyMediumSceneIds.HEATING_VENTILATION_AND_AIR_CONDITIONING]: {
    active: haActive,
    passive: haPassive,
  },
  [EnergyMediumSceneIds.INDUSTRIAL_LIQUIDS]: {
    active: IndustrialLiquidActive,
    passive: IndustrialLiquidPassive,
  },
  [EnergyMediumSceneIds.ELEC]: {
    active: electricityActive,
    passive: electricityPassive,
  },
};

// 时间颗粒度
export enum DateType {
  MIN = '1M',
  DAY = 'D',
  MONTH = 'M',
}

export const DateTypeDisplay = {
  [DateType.MIN]: '1分钟',
  [DateType.DAY]: '按日',
  [DateType.MONTH]: '按月',
};

// 生产时段
export enum Status {
  NORMAL = 1, // 生产时段
  NO_NORMAL = 2, // 非生产时段
}
export const StatusDisplay = {
  [Status.NORMAL]: '生产时段',
  [Status.NO_NORMAL]: '非生产时段',
};

export const getTimeAxis = (aggrby: DateType, time: number) => {
  switch (aggrby) {
    case DateType.MIN:
      return dayjs(time).format('MM-DD HH:mm');
    case DateType.DAY:
      return dayjs(time).format('YYYY-MM-DD');
    case DateType.MONTH:
      return dayjs(time).format('YYYY-MM');
    default:
      return '--';
  }
};
